/**
 * Component Registry for American Landmark Corporate Theme
 *
 * Extends the base corporate-multidomain theme registry with ALA pages,
 * search, and the templated community landing page.
 */

import './ala-theme.css';
import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-corporate-multidomain/registry';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomeHero } from './components/HomeHero';
import { HomeAbout } from './components/HomeAbout';
import { HomeStats } from './components/HomeStats';
import { HomeBrand } from './components/HomeBrand';
import { HomeTestimonials } from './components/HomeTestimonials';
import { HomeLandmark360 } from './components/HomeLandmark360';
import { HomePrimeLiving } from './components/HomePrimeLiving';
import { HomeGallery } from './components/HomeGallery';
import { AboutHero } from './components/AboutHero';
import { AboutContent } from './components/AboutContent';
import { CareersContent } from './components/CareersContent';
import { CareersHero } from './components/CareersHero';
import { FeaturedProjectDetail } from './components/FeaturedProjectDetail';
import { InvestorsContent } from './components/InvestorsContent';
import { InvestorsHero } from './components/InvestorsHero';
import { InvestorsApproach } from './components/InvestorsApproach';
import { InvestorsStats } from './components/InvestorsStats';
import { InvestorsCopyContent } from './components/InvestorsCopyContent';
import { InvestorsCopyHero } from './components/InvestorsCopyHero';
import { InsightsContent } from './components/InsightsContent';
import { InsightsHero } from './components/InsightsHero';
import { NewsArticleDetail } from './components/NewsArticleDetail';
import { NewsContent } from './components/NewsContent';
import { NewsHero } from './components/NewsHero';
import { Landmark360Content } from './components/Landmark360Content';
import { Landmark360Hero } from './components/Landmark360Hero';
import { ResidentPortalContent } from './components/ResidentPortalContent';
import { ResidentPortalHero } from './components/ResidentPortalHero';
import { TeamContent } from './components/TeamContent';
import { TeamHero } from './components/TeamHero';
import { TeamMemberBio } from './components/TeamMemberBio';
import { CultureContent } from './components/CultureContent';
import { CultureHero } from './components/CultureHero';
import { StrategyContent } from './components/StrategyContent';
import { StrategyHero } from './components/StrategyHero';
import { ImpactContent } from './components/ImpactContent';
import { ImpactHero } from './components/ImpactHero';
import { PageHero } from './components/PageHero';
import { PageBody } from './components/PageBody';
import { CommunitiesHero } from './components/CommunitiesHero';
import { CommunitiesMap } from './components/CommunitiesMap';
import { CommunitiesList } from './components/CommunitiesList';
import { CommunityLanding } from './components/CommunityLanding';
import { ContactForm } from './components/ContactForm';
import { ContactHero } from './components/ContactHero';
import { FaqsHero } from './components/FaqsHero';
import { FaqsContent } from './components/FaqsContent';
import { AlOneHero } from './components/AlOneHero';
import { AlOneContent } from './components/AlOneContent';
import { AlOneCtaStrip } from './components/AlOneCtaStrip';

const americanlandmarkOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  Hero: HomeHero,
  HomeAbout,
  HomeStats,
  HomeBrand,
  HomeTestimonials,
  HomeLandmark360,
  HomePrimeLiving,
  HomeGallery,
  AboutHero,
  AboutContent,
  CareersContent,
  CareersHero,
  FeaturedProjectDetail,
  InvestorsContent,
  InvestorsHero,
  InvestorsStats,
  InvestorsApproach,
  InvestorsCopyContent,
  InvestorsCopyHero,
  InsightsContent,
  InsightsHero,
  NewsHero,
  NewsContent,
  NewsArticleDetail,
  Landmark360Content,
  Landmark360Hero,
  ResidentPortalContent,
  ResidentPortalHero,
  TeamHero,
  TeamContent,
  TeamMemberBio,
  CultureContent,
  CultureHero,
  StrategyContent,
  StrategyHero,
  ImpactContent,
  ImpactHero,
  PageHero,
  PageBody,
  CommunitiesHero,
  CommunitiesMap,
  CommunitiesList,
  CommunityLanding,
  ContactForm,
  ContactHero,
  FaqsHero,
  FaqsContent,
  AlOneHero,
  AlOneContent,
  AlOneCtaStrip,
};

export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...americanlandmarkOverrides,
};

export default registry;
